import { css } from '@emotion/css';
import { Logo } from '@/components/UI/svg/CES';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ces/pc/');

export default function SectionA() {
    const { useLang } = useGlobal();
    const { t } = useLang('ces2023.sectionA');

    return (
        <div className="sectionA">
            <div
                className={css`
                    width: 100%;
                    height: 100%;
                    background-color: #000;
                    position: relative;
                `}
            >
                <EFPic name={['01-bg.webp', '01-bg.jpg']} />
                <div
                    className={css`
                        width: 1920px;
                        height: 800px;
                        position: absolute;
                        z-index: 2;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%, 0);
                    `}
                >
                    <div className="textContainer">
                        <div className="tip">
                            <div className="titleIcon">
                                <Logo />
                            </div>
                            <div className="split"></div>
                            <div className="ces">
                                <EFPic name={['01-4.webp', '01-4.png']} />
                            </div>
                        </div>
                        <div className="title">{t('title')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
